export default __webpack_public_path__ + "static/media/gradientBg.535e293e.png";